import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess, loginFailure } from "../../redux/slices/authSlice";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.scss";

const Login = () => {
  const [identifier, setIdentifier] = useState(""); // Can be email or phone number
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);

  const [identifierError, setIdentifierError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phonePattern = /^\d{10}$/; // Only 10 digits
    return phonePattern.test(phoneNumber);
  };

  const validateForm = () => {
    let isValid = true;
    setIdentifierError("");
    setPasswordError("");

    if (identifier.trim() === "") {
      setIdentifierError("Email or phone number is required.");
      isValid = false;
    } else if (validateEmail(identifier)) {
      // Valid email, no action needed
    } else if (validatePhoneNumber(identifier)) {
      // Valid phone number, no action needed
    } else {
      setIdentifierError("Please enter a valid email or 10-digit phone number.");
      isValid = false;
    }

    if (password.trim() === "") {
      setPasswordError("Password is required.");
      isValid = false;
    }

    return isValid;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // If validation fails, don't proceed
    }

    try {
      const response = await axios.post(
        "https://drdahousingapi-d6e7ejg3dbcybbhq.southindia-01.azurewebsites.net/api/Users/Login",
        {
          username: identifier, // Can be email or phone number
          password,
        }
      );

      if (response.status === 200) {
        const userData = response.data;
        dispatch(loginSuccess(userData));
        history.push("/main");
      } else {
        handleLoginError(response.data);
      }
    } catch (error) {
      dispatch(loginFailure());
      handleLoginError(error.response ? error.response.data : {});
      console.error("Error during login:", error);
    }
  };

  const handleLoginError = (errorData) => {
    if (errorData.error) {
      // If the error contains "password" but no "username", it means the identifier is correct but the password is wrong
      if (errorData.error.includes("password") && !errorData.error.includes("username")) {
        setPasswordError("Enter correct password.");
      } else if (errorData.error.includes("username")) {
        setIdentifierError("Invalid email or phone number.");
      }
      if (errorData.error.includes("password")) {
        setPasswordError("Invalid password.");
      }
    } else {
      setIdentifierError("Invalid email or phone number.");
      setPasswordError("Invalid password.");
    }
  };

  return (
    <div className="LoginContainer">
      <div className="image-side">
        <img src={'images/login.jpg'} alt="Logo" />
      </div>
      <div className='login-form'>
        <div className="login-img">
          <img src={'images/favicon.png'} alt="Logo" />
        </div>
        <h2>LOGIN</h2>
        <form onSubmit={handleLogin}>
          <div className="login-input"> 
          <label>
            Email or Phone:
            </label>
            <input
              type="text"
              value={identifier}
              className={identifierError ? "input-error" : ""}
              onChange={(e) => {
                setIdentifier(e.target.value);
                setIdentifierError(""); // Clear the error when typing starts
              }}
            />
            {identifierError && <p className="error-message">{identifierError}</p>}
            </div>
            <div className="login-input">
          <label>
            Password: </label>
            <div className="password-container">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                className={passwordError ? "input-error" : ""}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError(""); // Clear the error when typing starts
                }}
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
            {passwordError && <p className="error-message">{passwordError}</p>}
         </div>
          
          <button type="submit" className="btn-signin">LOG IN</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
